(function () {
  var SWIPER_POLL_MS = 40;
  var SWIPER_MAX_POLLS = 80;

  function waitForSwiper(root, attempt, onReady) {
    if (typeof Swiper !== 'undefined') {
      onReady();
      return;
    }
    if (attempt >= SWIPER_MAX_POLLS) return;
    root._ifFcWaitT = setTimeout(function () {
      waitForSwiper(root, attempt + 1, onReady);
    }, SWIPER_POLL_MS);
  }

  function initSwiper(root) {
    if (!root) return;
    var el = root.querySelector('.if-fc__swiper');
    if (!el) return;
    if (el.dataset.ifFcInitialized === 'true') return;

    var prev = root.querySelector('.if-fc__nav--prev');
    var next = root.querySelector('.if-fc__nav--next');

    function runInit() {
      if (el.dataset.ifFcInitialized === 'true') return;

      if (el.querySelectorAll('.swiper-slide').length <= 1) {
        if (prev) prev.classList.add('swiper-button-disabled');
        if (next) next.classList.add('swiper-button-disabled');
        el.dataset.ifFcInitialized = 'true';
        return;
      }

      var swiper = new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,
        watchOverflow: true,
        speed: 450,
        navigation: {
          prevEl: prev,
          nextEl: next,
        },
        breakpoints: {
          750: {
            spaceBetween: 18,
            slidesOffsetBefore: 18,
            slidesOffsetAfter: 18,
          },
          990: {
            spaceBetween: 22,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
      });

      el.dataset.ifFcInitialized = 'true';
      el._ifFcSwiper = swiper;

      function onResize() {
        if (swiper && typeof swiper.update === 'function') {
          swiper.update();
        }
      }

      root._ifFcResize = onResize;
      window.addEventListener('resize', onResize);
    }

    waitForSwiper(root, 0, runInit);
  }

  function destroyRoot(root) {
    if (!root) return;
    if (root._ifFcWaitT) {
      clearTimeout(root._ifFcWaitT);
      root._ifFcWaitT = null;
    }
    if (root._ifFcResize) {
      window.removeEventListener('resize', root._ifFcResize);
      root._ifFcResize = null;
    }
    var el = root.querySelector('.if-fc__swiper');
    if (el && el._ifFcSwiper) {
      try {
        el._ifFcSwiper.destroy(true, true);
      } catch (e) {}
      el._ifFcSwiper = null;
      el.dataset.ifFcInitialized = 'false';
    }
  }

  /* ── Hover-video: play on mouseenter, pause+reset on mouseleave ── */
  function initHoverVideos(root) {
    if (!root) return;
    root.querySelectorAll('.if-fc-card__img--hover-video').forEach(function (video) {
      var wrap = video.closest('.if-fc-card__media-wrap');
      if (!wrap || wrap._ifFcVideoBound) return;
      wrap._ifFcVideoBound = true;

      wrap.addEventListener('mouseenter', function () {
        video.play().catch(function () {});
      });

      wrap.addEventListener('mouseleave', function () {
        video.pause();
        video.currentTime = 0;
      });
    });
  }

  function scan() {
    document.querySelectorAll('[data-if-featured-collection]').forEach(function (root) {
      initSwiper(root);
      initHoverVideos(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var t = ev.target;
    if (!t) return;
    var root = t.querySelector ? t.querySelector('[data-if-featured-collection]') : null;
    if (root) {
      initSwiper(root);
      initHoverVideos(root);
    } else if (t.matches && t.matches('[data-if-featured-collection]')) {
      initSwiper(t);
      initHoverVideos(t);
    }
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var t = ev.target;
    if (!t) return;
    var root = t.querySelector ? t.querySelector('[data-if-featured-collection]') : null;
    if (root) destroyRoot(root);
    else if (t.matches && t.matches('[data-if-featured-collection]')) destroyRoot(t);
  });
})();
